module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "market"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "fliter type"
  }, [_vm._v("\n                        分类选择：\n                        "), _c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.fliter_type),
      callback: function($$v) {
        _vm.fliter_type = $$v
      },
      expression: "fliter_type"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "left searchBtn",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fliterGoods
    }
  }, [_vm._v("筛选")])]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn cart"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addGoods
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gouwuche"
  }), _vm._v(" "), _c('span', [_vm._v("购物车")]), _vm._v(" "), (_vm.seledGoodCount > 0) ? _c('span', {
    staticClass: "cart-count"
  }, [_c('b', [_vm._v(_vm._s(_vm.seledGoodCount))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.vipData.length > 6
    }
  }, _vm._l((_vm.vipData), function(item, idx) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "4%"
      },
      domProps: {
        "textContent": _vm._s(item.id ? (idx + 1) : '')
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "img",
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": "点击查看大图"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "img_box",
      on: {
        "click": function($event) {
          return _vm.bigImg(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "title": item.productName
      },
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.productTypeName)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      },
      domProps: {
        "textContent": _vm._s(item.spec)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      },
      domProps: {
        "textContent": _vm._s(item.amount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "6%"
      }
    }, [_c('span', {
      class: item.notice ? 'notice active' : 'notice'
    }, [_vm._v(_vm._s(item.id ? (item.notice ? item.notice : "暂无备注") : ""))])]), _vm._v(" "), _c('td', {
      staticClass: "add-count",
      staticStyle: {
        "width": "6%"
      }
    }, [(item.id) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.count),
        expression: "item.count"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.count)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "count", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline add-cart",
      on: {
        "click": function($event) {
          return _vm.addCart(item)
        }
      }
    }, [_c('span', {
      staticClass: "iconfont icon-jiarugouwuche",
      attrs: {
        "title": "加入购物车"
      }
    }, [_vm._v("添加至购物车")])]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    attrs: {
      "title": '购物车',
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "cart-info"
  }, [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('ul', {
    staticClass: "head"
  }, [_c('li', [_c('span', {
    staticStyle: {}
  }, [_vm._v("序号")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("图片")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("商品名")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticStyle: {}
  }, [_vm._v("单价")])])]), _vm._v(" "), (_vm.cartList.length) ? _c('div', {
    staticClass: "goods-list"
  }, [_c('ul', _vm._l((_vm.cartList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
      staticClass: "goods-img"
    }, [_c('img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('span', {
      staticClass: "goods-count"
    }, [_c('i', {
      staticClass: "iconfont icon-jianshao",
      on: {
        "click": function($event) {
          return _vm.reduCount(item)
        }
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.count))]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-tianjia-xue",
      on: {
        "click": function($event) {
          return _vm.addCount(item)
        }
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.amount))])])
  }), 0)]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_vm._v("\n                    暂无选购商品\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("请选择收货地址：")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    model: {
      value: (_vm.addr),
      callback: function($$v) {
        _vm.addr = $$v
      },
      expression: "addr"
    }
  }, _vm._l((_vm.addrList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.address,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "total-money"
  }, [_vm._v("\n                    总金额：" + _vm._s(_vm.totalAmount) + "\n                ")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goSelPayType
    }
  }, [_vm._v("结账")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "备注",
      "visible": _vm.showNotice,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showNotice = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "1%"
    }
  }, [_vm._v(_vm._s(_vm.note))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showNotice = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showNotice = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择支付方式",
      "visible": _vm.showPayType,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPayType = $event
      }
    }
  }, [_c('div', {
    staticClass: "pay-type"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "wechat",
    on: {
      "click": function($event) {
        return _vm.selPayType('wechat')
      }
    }
  }, [_vm._v("微信")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ali",
    on: {
      "click": function($event) {
        return _vm.selPayType('ali')
      }
    }
  }, [_vm._v("支付宝")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "other",
    on: {
      "click": function($event) {
        return _vm.selPayType('other')
      }
    }
  }, [_vm._v("先下单后结账")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "支付二维码",
      "visible": _vm.showPayCode,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPayCode = $event
      }
    }
  }, [_c('div', {
    staticClass: "pay-code"
  }, [_c('div', {
    staticClass: "pay-time"
  }, [_vm._v("支付剩余时间:" + _vm._s(_vm.payOutTime))]), _vm._v(" "), (_vm.showPayCode) ? _c('div', {
    attrs: {
      "id": "qrCode"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.showBigImg) ? _c('div', {
    staticClass: "big-img",
    on: {
      "click": function($event) {
        _vm.showBigImg = false;
      }
    }
  }, [_c('div', {
    staticClass: "big-img-wrap"
  }, [_c('img', {
    attrs: {
      "src": _vm.bigImgUrl,
      "alt": ""
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("分类")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("规格")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("备注")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("购买数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-01130292","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/market/market.vue
// module id = 910
// module chunks = 1